import Component from '@glimmer/component'
import { service } from '@ember/service'
import type BookLibraryCollectionShowRoute from 'teacher-ui-client/subscription-type/book-library/collection/show/route'
import type BookLibraryCollectionShowController from 'teacher-ui-client/subscription-type/book-library/collection/show/controller'
import { FidgetLoadingIndicatorComponent } from '@blakeelearning/fidget/components/fidget/loading-indicator'
import { BookLibraryCollectionShow } from 'teacher-ui-client/components/page/book-library/collection/show'
import type BookLibraryCollectionService from 'teacher-ui-client/services/book-library/collection'
import { or } from 'ember-truth-helpers'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<BookLibraryCollectionShowRoute>
    controller: BookLibraryCollectionShowController
  }
}

export class BookLibraryCollectionShowPage extends Component<Signature> {
  @service('book-library/collection') collectionService!: BookLibraryCollectionService

  <template>
    {{#if
      (or @model.loadCollection.isRunning @model.loadBookCollections.isRunning @model.loadPrimaryFilters.isRunning)
    }}
      <FidgetLoadingIndicatorComponent
        data-test-collection-show-loading
        @show={{true}}
        @centered={{true}}
        @overlay={{false}}
      />

      {{! using 'and' helper for both these values doesn't get recognised by ts linting, hence the nested if blocks }}
    {{else if @model.loadCollection.value}}
      {{#if @model.loadPrimaryFilters.value}}
        <BookLibraryCollectionShow
          @collection={{@model.loadCollection.value}}
          @collections={{this.collectionService.allMyCollections}}
          @primaryFilters={{@model.loadPrimaryFilters.value}}
        />
      {{/if}}
    {{/if}}
  </template>
}

export default RouteTemplate(BookLibraryCollectionShowPage)
